import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/MeetingRecord";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetActive = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Active`, options);

export const Start = (options) => GENERATE_URL(`${PREFIX_URL}/Start`, options);

export const UpdateNote = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Note`, options);

export const Complete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Complete`, options);

export default {
  GetAll,
  GetActive,
  Start,
  UpdateNote,
  Complete,
};
